import React from 'react';
import ListComponent from "./ListComponent";
import DropDown from "../Design/DropDown";
import OurTeamList from "../Design/OurTeamList";
import WindowLocation from "../Services/WindowLocation";
import axios from "axios";
import Navigation from "../Design/Navigation";

export default class OurTeam extends ListComponent {
    constructor(props) {
        super(props);

        this.handleDropDown = this.handleDropDown.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.filterData = this.filterData.bind(this);
        this.changeTypes = this.changeTypes.bind(this);

        this.s = null;

        this.refSearchInput = React.createRef();
    }

    componentDidMount() {
        if (!window.location.getHashObj) {
            WindowLocation.getWindowLocation();
        }

        this.setDefaultParams().then(() => {
            if (window.location.hashObj && window.location.getHashObj('s')) {
                this.s = (window.location.hashObj && window.location.getHashObj('s')) ? window.location.getHashObj('s') : '';
                this.updateParams('s', window.location.getHashObj('s'));
            } else {
                this.requestList(axios.get(this.source, {
                    params: this.state.params
                }));
            }
        });
    }

    resetParams(callback = () => {
    }) {
        if(this.refSearchInput && this.refSearchInput.current) {
            this.refSearchInput.current.value = '';
        }

        super.resetParams(callback);
    }

    changeTypes(type) {
        if (!type) {
            return;
        }

        const {config: {params}} = this;

        this.setDefaultParams().then(() => {
            this.resetParams(()=> {
                window.location.addHash(params.types.key, type.slug);
                window.location.removeHash('s');

                WindowLocation.rewriteUrl();

                this.updateParams(params.types.key, type.slug);
            });
        });
    }

    requestList(request) {
        request.then(({data: list, request}) => {
            this.getResponseTotalPages(request);
            this.getResponseTotalPosts(request);

            const {loadMore, loaded, list: oldList} = this.state;
            let oL = oldList;

            if (!loadMore && !loaded) {
                oL = [];
            }

            this.list = oL.concat(list);

            this.setState({
                list: [...this.list],
                loaded: true,
                loadMore: false
            });
        }).catch((error) => {
            this.setState({
                loaded: true,
                loadMore: false
            });
        });
    }

    getList() {
        this.setState({
            loaded: false
        }, async () => {
            await this.sleep(350);

            this.requestList(axios.get(this.source, {
                params: this.state.params
            }));
        });
    }

    filterData() {
        const {params, list: stateList} = this.state;
        let search = (params && params.s) ? params.s : null;
        let humans = [...stateList];

        if (params && ((params.s && params.s.length > 0) || (params.service))) {
            const regex = new RegExp("([^\\w]+)", 'ig');
            search = search ? search.replace(regex, '') : null;

            for (let region in humans) {
                if (!humans.hasOwnProperty(region) || !humans[region].bios || humans[region].bios.length < 1) {
                    continue;
                }

                const {bios} = humans[region];

                let bs = Object.values(bios).filter(bio => {
                    let isSearch = (search && search.length > 0);
                    let keywordsSearch = `${bio.firstname}${bio.lastname}${bio.title}`;
                    keywordsSearch = keywordsSearch.replace(regex, '');
                    let isValidSearch = (isSearch && keywordsSearch.toLowerCase().search(search.toLowerCase()) > -1);

                    let isServices = (params && params.service);
                    let isValidService = (isServices && bio.services.hasOwnProperty(params.service));

                    return ((isSearch && isServices && isValidSearch && isValidService) || (isSearch && !isServices && isValidSearch) || (!isSearch && isServices && isValidService));
                });

                humans[region].bios = bs;
            }

            this.setState({
                list: humans,
                loaded: true
            });
        }
    }

    handleDropDown(key, value) {
        if (value) {
            window.location.addHash(key, value);
        } else {
            window.location.removeHash(key);
        }

        WindowLocation.rewriteUrl();

        this.updateParams(key, value ? value : null);
    }

    handleSearch({currentTarget: {value: search}}) {
        let searchKey = this.config.params.search.key ? this.config.params.search.key : 's';

        this.setState({
            params: {
                ...this.state.params,
                [searchKey]: search
            }
        });

        if (this.querySearchTimeOut) {
            clearTimeout(this.querySearchTimeOut);
        }

        this.querySearchTimeOut = setTimeout(() => {
            if (search && search.length > 0) {
                window.location.addHash('s', search);
            } else {
                window.location.removeHash('s');
            }

            WindowLocation.rewriteUrl();

            this.updateParams('s', search);
        }, 300);
    }

    render() {
        const {page, state: {list, loaded, totalPages, params: activeParams}, config: {params}, source} = this;

        return <>
            {(params.types && params.types.render && params.types.render !== false) &&
            <Navigation active={activeParams[params.types.key]} links={params.types.render.values}
                        className={'is-style-large'}
                        onClick={this.changeTypes}/>}

            <div className="filter-bar styled-select">
                <div>
                    Filter By:
                    {params && Object.entries(params).map(([key, param]) => (param.render && param.render !== false && param.app && param.app === 'DropDown') ?
                        <DropDown name={param.key}
                                  options={param.render.values}
                                  defaultValue={activeParams[param.key]}
                                  onChange={(val) => this.handleDropDown(param.key, val)}/> : null)}
                </div>
                <div className={"search"}>
                    <input type="text" placeholder="Search for name/keyword" onChange={this.handleSearch}
                           defaultValue={activeParams[params.search.key]} ref={this.refSearchInput}/>
                </div>
            </div>
            {loaded && list && list.map(team => team.bios && Object.values(team.bios).length > 0 && <>
                <h3 className="align-center is-style-dark-grey">{team.label}</h3>
                <OurTeamList team={Object.values(team.bios)}/>
            </>)}
            {(loaded && list && list[0] && list[0].bios.length === 0) && <p>No results found.</p>}
            {!loaded && <div className={"load-more-container"}>
                <div className={"fp-loading"}><span></span><br/> Loading</div>
            </div>}
        </>
    }
}